import { useTranslation } from 'react-i18next';

import { GROUPS } from '@/service/apiConf';

const group = GROUPS.ophub;

/**
 * 费用中心 - 订单管理（菜单 title: orderManagement）
 *
 * 页面：`pages/order/list`、`pages/order/details`（不含下单 create）
 * - GET order-items              → list（与运营中心总览互不依赖）
 * - GET resources/available-deployment-types → 非标准，鉴权 Resource=resources Verb=get（列表交付类型筛选项）
 * - GET order-items/{id}         → get（可见依赖仅 list；Tab 接口 skus/resources/invoices 为隐藏联动，不作为回显门槛）
 * - GET order-items/{id}/invoices → order-items/invoices.list（详情「关联账单」Tab，隐藏）
 * - GET skus                     → skus.get（详情「规格详情」Tab，隐藏；与产品 SKU 页共用 key）
 * - GET resources                → resources.get（详情「资源配置」Tab + 列表筛选项共用；与原子资源页共用 key）
 */
export function useOrderManagement() {
  const { t } = useTranslation();
  return {
    group,
    title: 'orderManagement',
    list: [
      {
        resource: 'order-items',
        list: [
          {
            type: 'list',
            relative: {
              onCheck: {
                // 列表筛选 available-deployment-types：非标准，鉴权只认 resources + get
                [`["${group}"].resources.get`]: true,
              },
              onUnCheck: {
                [`["${group}"].order-items.get`]: undefined,
                [`["${group}"].order-items/invoices.list`]: undefined,
                [`["${group}"].skus.get`]: undefined,
                [`["${group}"].resources.get`]: undefined,
              },
            },
            name: <span>list: {t('common:list')}</span>,
          },
          {
            type: 'get',
            relative: {
              onCheck: {
                [`["${group}"].order-items.list`]: true,
                // 详情 Tab：规格详情 / 资源配置 / 关联账单
                [`["${group}"].skus.get`]: true,
                [`["${group}"].resources.get`]: true,
                [`["${group}"].order-items/invoices.list`]: true,
              },
            },
            name: <span>get: {t('order:order.details')}</span>,
          },
          {
            resource: 'skus',
            type: 'get',
            hidden: true,
            name: <span>get: {t('common:specification.details')}</span>,
          },
          {
            // 详情「资源配置」Tab + 列表交付类型筛选项（available-deployment-types）共用
            resource: 'resources',
            type: 'get',
            hidden: true,
            name: <span>get: {t('common:resource.configuration')}</span>,
          },
          {
            resource: 'order-items/invoices',
            type: 'list',
            hidden: true,
            name: <span>list: {t('order:related.bills')}</span>,
          },
        ],
      },
    ],
  };
}

/**
 * 费用中心 - 账单管理（菜单 title: billManagement1）
 *
 * 页面：`pages/data-center/cost-center/bill-management`
 * - GET invoices      → list（与运营中心总览互不依赖）
 * - GET invoices/{id} → get（列表 ID 可点进详情）
 */
export function useBillingManagement() {
  const { t } = useTranslation();
  return {
    group,
    title: 'billManagement1',
    list: [
      {
        resource: 'invoices',
        list: [
          {
            type: 'list',
            relative: {
              onUnCheck: {
                [`["${group}"].invoices.get`]: undefined,
              },
            },
            name: <span>list: {t('common:list')}</span>,
          },
          {
            type: 'get',
            relative: {
              onCheck: {
                [`["${group}"].invoices.list`]: true,
              },
            },
            name: <span>get: {t('data-center:bill.details')}</span>,
          },
        ],
      },
    ],
  };
}

// 充值记录
export function useRechargeRecords() {
  const { t } = useTranslation();
  return {
    group: GROUPS.ophub,
    title: 'rechargeRecords',
    list: [
      {
        list: [
          {
            resource: 'recharge-requests',
            type: 'list',
            name: <span>list: {t('common:list')}</span>,
          },
        ],
      },
    ],
  };
}
